import { IMondayContext } from "@/types/response/monday/context";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { getContext } from '@/utils/http';
import queryKeys from "@/constants/queryKeys";

const useGetContextQuery = (options?: UseQueryOptions<IMondayContext>): UseQueryResult<IMondayContext> => {
  return useQuery<IMondayContext>(queryKeys.MONDAY_GET_CONTEXT, async () => {
    const context = await getContext();
    if (!context) {
      throw new Error('Context is undefined');
    }
    //TODO: fix types
    return context as unknown as IMondayContext;
  }, options);
};

export default useGetContextQuery;
